import { Fragment } from 'react';
import './App.css';
import Routing from './Routing'
import CssBaseline from '@material-ui/core/CssBaseline';

function App() {
  return (
    <Fragment>
      <CssBaseline />
      <Routing />
    </Fragment>
  );
}

export default App;
